import { render, staticRenderFns } from "./home-id.vue?vue&type=template&id=440e244c&scoped=true"
import script from "./home-id.vue?vue&type=script&lang=js"
export * from "./home-id.vue?vue&type=script&lang=js"
import style0 from "./home-id.vue?vue&type=style&index=0&id=440e244c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440e244c",
  null
  
)

export default component.exports